import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyNote, HttpResponse } from "@/types";

export function useDeleteCompanyNote() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({ companyNoteId }: { companyNoteId: number }) => {
      const path = `companies/${currentCompanyId}/company-notes/${companyNoteId.toString()}`;
      const res = await guacHttpClient.delete<
        CompanyNote,
        HttpResponse<CompanyNote>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
